import { useContext } from 'react';

import { PresetsContext } from '../../PresetsContext';
import { useShareGroup } from '../../data';
import { useDeleteGroup, useRenameGroup } from '../../data';
import GroupActionsComponent from './GroupActions';

const GroupActions = ({ limit, isPublic, actions, ...item }) => {
  const { presetKey } = useContext(PresetsContext);
  const [shareGroup] = useShareGroup(presetKey);
  const [renameGroup] = useRenameGroup(presetKey);
  const [deleteGroup] = useDeleteGroup(presetKey);

  const handleShare = () => {
    shareGroup({ ...item, isPublic: !isPublic, title: item.name });
  };
  const handleRename = () => {
    renameGroup(item);
  };
  const handleRemove = () => {
    deleteGroup(item);
  };

  return item?.id ? (
    <GroupActionsComponent
      limit={limit}
      onShare={handleShare}
      onRename={handleRename}
      onRemove={handleRemove}
      isPublic={isPublic}
      actions={actions}
    />
  ) : null;
};

export default GroupActions;
